// Plantilles d'obligacions normatives per a restaurants
export const COMPLIANCE_TEMPLATES = {
  rgpd: [
    {
      title: "Registre d'activitats de tractament",
      description: "Mantenir un registre intern de totes les activitats de tractament de dades personals (art. 30 RGPD). Inclou: finalitat, categories de dades, destinataris, terminis de supressió.",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Política de privacitat actualitzada",
      description: "Disposar d'una política de privacitat accessible als clients i treballadors que informi sobre el tractament de les seves dades (art. 13-14 RGPD).",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Consentiment per a càmeres de vigilància",
      description: "Si hi ha càmeres, cal informar-ne als empleats i clients mitjançant cartells, i disposar del formulari de consentiment o base legal per al tractament.",
      priority: "high",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Contractes amb encarregats del tractament",
      description: "Signar acords de tractament de dades (DPA) amb proveïdors que accedeixen a dades personals: gestoria, software TPV, plataformes de reserves, etc.",
      priority: "high",
      review_period_months: 36,
      is_mandatory: true,
    },
    {
      title: "Procediment d'exercici de drets ARCO-POL",
      description: "Disposar d'un procediment documentat per atendre les sol·licituds d'accés, rectificació, cancel·lació, oposició, portabilitat, limitació i oblit.",
      priority: "medium",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Formació del personal en protecció de dades",
      description: "Formar tots els empleats que tracten dades personals sobre les obligacions del RGPD, la confidencialitat i els procediments interns.",
      priority: "medium",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Anàlisi de risc o EIPD si escau",
      description: "Realitzar una avaluació d'impacte en protecció de dades si es processen dades a gran escala o categories especials (art. 35 RGPD).",
      priority: "medium",
      review_period_months: 24,
      is_mandatory: false,
    },
  ],
  prl: [
    {
      title: "Avaluació de riscos laborals",
      description: "Realitzar i documentar l'avaluació de riscos del centre de treball, identificant perills (talls, cremades, lliscades, soroll, etc.) i mesures preventives.",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Pla de prevenció de riscos laborals",
      description: "Elaborar un pla de prevenció que integri la seguretat i salut en l'activitat diària del restaurant, amb responsables i activitats preventives.",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Vigilància de la salut dels treballadors",
      description: "Garantir reconeixements mèdics periòdics als treballadors (voluntaris o obligatoris segons el risc). Coordinació amb el servei de prevenció aliè.",
      priority: "high",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Formació en PRL per a nous treballadors",
      description: "Proporcionar formació específica en riscos del lloc de treball a cada treballador en el moment de la incorporació i quan canviï les seves tasques.",
      priority: "high",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Pla d'emergència i evacuació",
      description: "Disposar d'un pla d'emergència actualitzat, amb mapes d'evacuació, responsables i procediments d'actuació en cas d'incendi o altra emergència.",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Equips de protecció individual (EPI)",
      description: "Proporcionar els EPI necessaris (guants, calçat antilliscant, protectors auditius si cal) i assegurar-se que els treballadors els utilitzen correctament.",
      priority: "high",
      review_period_months: 6,
      is_mandatory: true,
    },
    {
      title: "Registre d'accidents i incidents de treball",
      description: "Portar un registre de tots els accidents i incidents laborals, investigar-ne les causes i implementar mesures correctives.",
      priority: "high",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Coordinació d'activitats empresarials",
      description: "Si hi ha empreses externes o autònoms que treballin al local, establir protocols de coordinació de seguretat (art. 24 LPRL).",
      priority: "medium",
      review_period_months: 12,
      is_mandatory: false,
    },
  ],
  harassment: [
    {
      title: "Protocol d'actuació contra l'assetjament sexual i per raó de sexe",
      description: "Disposar d'un protocol que estableixi els procediments per prevenir i actuar davant casos d'assetjament sexual o per raó de sexe (obligatori empreses +25 treballadors, recomanable totes).",
      priority: "critical",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Protocol d'actuació contra l'assetjament laboral (mobbing)",
      description: "Disposar d'un procediment intern per atendre denúncies d'assetjament laboral, amb garanties de confidencialitat i protecció de la persona denunciant.",
      priority: "high",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Canal de denúncia intern",
      description: "Habilitar un canal confidencial (bústia, email o persona de confiança) per presentar denúncies d'assetjament o conductes irregulars.",
      priority: "high",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Formació i sensibilització del personal",
      description: "Impartir formació a tots els empleats sobre igualtat, prevenció de l'assetjament i respecte en l'entorn laboral.",
      priority: "high",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Pla d'igualtat (si +50 treballadors)",
      description: "Les empreses de 50 o més treballadors estan obligades a disposar d'un pla d'igualtat registrat. Per sota d'aquesta xifra és voluntari però recomanat.",
      priority: "medium",
      review_period_months: 48,
      is_mandatory: false,
    },
    {
      title: "Clàusules d'igualtat als contractes",
      description: "Incloure en els contractes laborals referència a la política d'igualtat i no discriminació de l'empresa.",
      priority: "medium",
      review_period_months: 36,
      is_mandatory: false,
    },
  ],
  appcc: [
    {
      title: "Pla APPCC documentat i actualitzat",
      description: "Disposar d'un sistema d'Anàlisi de Perills i Punts de Control Crític (APPCC) documentat, específic per a l'establiment i les seves activitats.",
      priority: "critical",
      review_period_months: 12,
      is_mandatory: true,
    },
    {
      title: "Control de temperatures (cadena de fred)",
      description: "Registrar les temperatures dels equips de fred (neveres, congeladors) i dels aliments en recepció. Documentar les incidències i accions correctives.",
      priority: "critical",
      review_period_months: 1,
      is_mandatory: true,
    },
    {
      title: "Formació en higiene alimentària del personal",
      description: "Tot el personal que manipula aliments ha de tenir formació en higiene alimentària (carnet de manipuladors o formació equivalent).",
      priority: "critical",
      review_period_months: 24,
      is_mandatory: true,
    },
    {
      title: "Control i registre de neteges i desinfeccions",
      description: "Disposar d'un programa de neteja i desinfecció amb registres de les tasques realitzades, productes utilitzats i responsables.",
      priority: "high",
      review_period_months: 3,
      is_mandatory: true,
    },
    {
      title: "Control de plagues (DDD)",
      description: "Contractar un servei professional de desinfecció, desinsectació i desratització (DDD) amb empresa autoritzada i conservar els registres de les visites.",
      priority: "high",
      review_period_months: 6,
      is_mandatory: true,
    },
    {
      title: "Control de l'aigua",
      description: "Verificar periòdicament la qualitat de l'aigua (clor residual, analítiques si cal) i documentar els controls realitzats.",
      priority: "high",
      review_period_months: 3,
      is_mandatory: true,
    },
    {
      title: "Traçabilitat de proveïdors i matèries primeres",
      description: "Mantenir registres de proveïdors, albarans i lotes per garantir la traçabilitat completa dels aliments.",
      priority: "high",
      review_period_months: 6,
      is_mandatory: true,
    },
    {
      title: "Gestió d'al·lèrgens",
      description: "Disposar d'informació actualitzada sobre els al·lèrgens presents en tots els plats i comunicar-los correctament als clients.",
      priority: "critical",
      review_period_months: 3,
      is_mandatory: true,
    },
    {
      title: "Revisió del pla APPCC per canvis significatius",
      description: "Revisar i actualitzar el pla APPCC quan es produeixin canvis significatius: nous productes, canvis de procés, reformes, nous proveïdors.",
      priority: "medium",
      review_period_months: 12,
      is_mandatory: true,
    },
  ],
};

export const AREA_CONFIG = {
  rgpd: {
    label: "Protecció de Dades (RGPD)",
    shortLabel: "RGPD",
    icon: "🔒",
    bg: "bg-blue-50",
    color: "text-blue-700",
    border: "border-blue-200",
    description: "Compliment del Reglament General de Protecció de Dades",
  },
  prl: {
    label: "Prevenció de Riscos Laborals",
    shortLabel: "PRL",
    icon: "🦺",
    bg: "bg-amber-50",
    color: "text-amber-700",
    border: "border-amber-200",
    description: "Seguretat i salut en el treball (LPRL i normativa complementària)",
  },
  harassment: {
    label: "Protocols contra l'Assetjament",
    shortLabel: "Assetjament",
    icon: "🤝",
    bg: "bg-purple-50",
    color: "text-purple-700",
    border: "border-purple-200",
    description: "Igualtat, assetjament sexual, laboral i discriminació",
  },
  appcc: {
    label: "Seguretat Alimentària (APPCC)",
    shortLabel: "APPCC",
    icon: "🍽️",
    bg: "bg-emerald-50",
    color: "text-emerald-700",
    border: "border-emerald-200",
    description: "Sistema d'Anàlisi de Perills i Punts de Control Crític",
  },
};